module.exports = __webpack_public_path__ + "img/D1.56cd3d7b.jpg";